import { store } from "./store/store";
import { Provider } from "react-redux";
import AppRoutes from "./pages/Routes";
import ScrrollToTop from "../src/components/ScrrollToTop";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "react-query";
import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { ThemeProvider } from "./context/ThemeProvider";
// import { disconnectSocket, initiateSocketConnection } from "./socket/socket";
import Cookies from "js-cookie";
import { FileProvider } from "./context/FileProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { StreamProvider } from "./context/StreamProvider";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { isEmailRequiredGate } from "./utils/emailGate";

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false, // ✅ disable retries
        refetchOnWindowFocus: false, // optional: disable on window focus
        refetchOnReconnect: false,   // optional
        refetchOnMount: false,       // optional
      },
    },
  });
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const token = Cookies.get("whoxa_web_token");

    if (!token) {
      if (
        location.pathname != "/privacy-policy" &&
        location.pathname != "/otp-verification" &&
        location.pathname != "/bind-email"
      ) {
        navigate("/login");
      }
    } else if (
      isEmailRequiredGate() &&
      location.pathname !== "/bind-email" &&
      location.pathname !== "/privacy-policy"
    ) {
      navigate("/bind-email");
    }
  }, []);

  useEffect(() => {
    sessionStorage.removeItem("callStartTime");
  }, []);

  return (
    <>
      {/* Set meta tags with react-helmet ====================================================================================*/}
      <Helmet>
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Whoxa web chat" />
        <meta
          property="og:description"
          content="Boost your business with an affordable, customizable WhatsApp Web clone that enhances communication and drives growth effortlessly."
        />
        <meta property="og:url" content="https://whoxachat.com/" />
        <meta property="og:site_name" content="Whoxa web chat" />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/primocys/image/upload/v1732606603/Chat_web_banner/Overview_kq7dcg.jpg"
        />
      </Helmet>
      <ScrrollToTop />
      <Provider store={store}>
        <ErrorBoundary>
          <ThemeProvider>
            <StreamProvider>
              <QueryClientProvider client={queryClient}>
                <FileProvider>
                  <AppRoutes />
                </FileProvider>
              </QueryClientProvider>
            </StreamProvider>
          </ThemeProvider>
        </ErrorBoundary>
      </Provider>
      <Toaster
        toastOptions={{ duration: 3000 }}
        position="bottom-right"
        reverseOrder={false}
      />
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
}

export default App;
